<template>
  <div class="amap-container">
    <!-- 搜索框 -->
    <div class="search-box">
      <div class="search-box-content">
        <el-input v-model="innerSearchText" @input="handleSearch" placeholder="请输入地址" @keyup.enter.native="handleSearch">
          <!--          <span slot="prepend">-->
          <!--            {{initPosition.provinceName}}{{initPosition.cityName}}{{initPosition.districtName}}-->
          <!--          </span>-->
        </el-input>
        <el-button type="primary" @click="handleSearch">搜索</el-button>
      </div>

      <div class="pois-box" v-if="poisData.length">
        <div class="pois-list" v-for="(item, index) in poisData" @click="selectLng(item)" :key="index">
          <div class="pois-list-title">{{ item.name }} {{ item.address }}</div>
        </div>
      </div>
    </div>

    <!-- 地图容器 -->
    <div id="map-container" style="width: 100%; height: 500px"></div>

    <!-- 选择后展示经纬度+地址 -->
    <div v-if="selectedPosition" class="position-info">地址信息: {{ selectedPosition.address || "未知" }}</div>
  </div>
</template>

<script>
import AMapLoader from "@amap/amap-jsapi-loader";
import { debounce } from "lodash";
import { orderFreightPreFee } from "@/views/CustomerServiceWorkbench/OrderQuery/api";

export default {
  name: "CustomMap",
  props: {
    initPosition: {
      type: Object,
      default: () => ({
        lng: "",
        lat: "",
        address: "",
        cityCode: "",
        cityName: "",
        districtCode: "",
        districtName: "",
        provinceCode: "",
        provinceName: ""
      }),
    },
    clickable: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      map: null,
      geocoder: null,
      marker: null,
      innerSearchText: "",
      selectedPosition: null,
      poisData: [],
    };
  },
  mounted() {
    this.initMap();
  },
  methods: {
    selectLng(item) {
      // console.log("1111111111", item)
      if (item.adcode !== this.initPosition.districtCode) {
        this.$message.error(`只能选择${this.initPosition.provinceName}${this.initPosition.cityName}${this.initPosition.districtName}的地址`)
        return
      }
      const lng = item.location.split(",")[0];
      const lat = item.location.split(",")[1];
      const address = item.name + item.address;

      this.innerSearchText = address;
      this.poisData = [];
      this.addMarker(lng, lat);

      this.selectedPosition = {
        location: {lng, lat},
        address: address,
      };
      this.$emit("position-change", this.selectedPosition);
    },

    // ====================== 新增：自动飞到指定区县 ======================
    flyToDistrict() {
      const {districtCode} = this.initPosition;
      if (!districtCode) return;

      const districtSearch = new AMap.DistrictSearch({
        level: "district",
        extensions: "all",
      });

      districtSearch.search(districtCode, (status, result) => {
        if (status === "complete" && result.districtList?.length) {
          const center = result.districtList[0].center;
          this.map.setCenter(center);
          this.map.setZoom(13);
        }
      });
    },

    initMap() {
      window._AMapSecurityConfig = {
        securityJsCode: "e91f06bab5d88c39e294f7f17fc4d203",
      };
      AMapLoader.load({
        key: "efc1307b7fb723a63df25c4654808f21",
        version: "2.0",
        plugins: ["AMap.Scale", "AMap.PlaceSearch", "AMap.Geocoder", "AMap.DistrictSearch"],
      }).then((AMap) => {
        this.map = new AMap.Map("map-container", {
          zoom: 13,
          center: this.initPosition.lng ? [this.initPosition.lng, this.initPosition.lat] : [116.478935, 39.997761],
        });

        // ====================== 自动定位到区县（新增） ======================
        this.flyToDistrict();

        if (this.initPosition.lng) {
          this.selectedPosition = {
            location: {lng: this.initPosition.lng, lat: this.initPosition.lat},
            address: this.initPosition.address,
          };
          this.innerSearchText = `${this.initPosition.address}`
          this.addMarker(this.initPosition.lng, this.initPosition.lat)
        } else {
          this.innerSearchText = `${this.initPosition.provinceName}${this.initPosition.cityName}${this.initPosition.districtName}`
          this.handleSearch()
        }
        this.geocoder = new AMap.Geocoder();

        if (this.clickable) {
          this.map.on("click", (e) => {
            const lng = e.lnglat.lng;
            const lat = e.lnglat.lat;

            this.geocoder.getAddress([lng, lat], (status, result) => {
              let address = "未知地址";
              if (status === "complete" && result.regeocode) {
                if (result.regeocode.addressComponent.adcode !== this.initPosition.districtCode) {
                  this.$message.error(`只能选择${this.initPosition.provinceName}${this.initPosition.cityName}${this.initPosition.districtName}的地址`)
                  return
                } else {
                  address = result.regeocode.formattedAddress;
                }
              }

              this.addMarker(lng, lat);
              this.innerSearchText = address;

              this.selectedPosition = {
                location: {
                  lng: lng,
                  lat: lat
                },
                address: address,
              };
              this.$emit("position-change", this.selectedPosition);
            });
          });
        }
      });
    },

    addMarker(lng, lat) {
      if (this.marker) this.map.remove(this.marker);
      this.marker = new AMap.Marker({
        position: [lng, lat],
        map: this.map,
      });
      this.map.setCenter([lng, lat]);
      this.map.setZoom(16);
    },
    handleSearch() {
      // 只执行一次创建防抖函数
      if (!this._debounceSearch) {
        this._debounceSearch = debounce(async () => {
          const searchText = this.innerSearchText?.trim() || '';
          if (!searchText) return;

          try {
            const res = await fetch(`https://restapi.amap.com/v3/place/text?key=f393d321cb4beb722adce2980b923d68&keywords=${encodeURIComponent(searchText)}&city=全国&extensions=all`);
            const data = await res.json();

            if (data.status === '1' && data.pois) {
              const TARGET_ADCODE = this.initPosition?.districtCode;
              this.poisData = TARGET_ADCODE
                ? data.pois.filter(p => p.adcode === TARGET_ADCODE)
                : data.pois;
            }
          } catch (e) {
            console.error('搜索失败', e);
          }
        }, 300);
      }
      // 调用
      this._debounceSearch();
    },
    // async handleSearch() {
    //   if (!this.innerSearchText.trim()) return;
    //   try {
    //     const res = await fetch(
    //         `https://restapi.amap.com/v3/place/text?key=f393d321cb4beb722adce2980b923d68&keywords=${encodeURIComponent(this.innerSearchText)}&city=全国&extensions=all`
    //     );
    //     const data = await res.json();
    //
    //     if (data.status === "1" && data.pois) {
    //       const TARGET_ADCODE = this.initPosition.districtCode;
    //       this.poisData = data.pois.filter((p) => p.adcode === TARGET_ADCODE);
    //     }
    //   } catch (e) {
    //     console.error("搜索失败", e);
    //   }
    // },

    setPosition(position) {
      if (position.lng && position.lat) {
        this.addMarker(position.lng, position.lat);
        this.innerSearchText = position.address || "";
      }
    },
    clearMarker() {
      if (this.marker) {
        this.map.remove(this.marker);
        this.marker = null;
      }
      this.selectedPosition = null;
      this.innerSearchText = "";
      this.poisData = [];
    },
  },
  beforeDestroy() {
    if (this.map) this.map.destroy();
  },
};
</script>

<style lang="scss" scoped>
.amap-container {
  width: 100%;
  height: 100%;
}

.search-box {
  position: relative;
  z-index: 100;

  .search-box-content {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 10px;
  }

  .pois-box {
    position: absolute;
    top: 44px;
    left: 0;
    width: 100%;
    background: #fff;
    border: 1px solid #eee;
    max-height: 250px;
    overflow-y: auto;

    .pois-list {
      padding: 10px 12px;
      cursor: pointer;
      border-bottom: 1px solid #f5f5f5;
    }
  }
}

.position-info {
  padding: 20px 10px 10px;
  font-size: 0.16rem;
  font-weight: bold;
  background: #ffffff;
}
</style>
